import { useContext, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { connect } from "react-redux";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { LocaleContext } from "../../../../routing/LangRouter";

//import general components
import BaseTitle from "../../../common/base-title/base-title";

//import view components
import IntFlightItem from "./int-flight-item";
import DayChange from "../../../common/day-change/day-change";
import IntFlightDetailsModal from "./int-flight-details-modal";

function IntFlightList({ flightList, setRequestFlag, setUid }) {
    //general variables
    const [searchParams] = useSearchParams();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { locale } = useContext(LocaleContext);

    //sessionStorage variables
    const intFlightInformation = JSON.parse(sessionStorage.getItem("intFlightInformation"));
    const { isAccommodation, isItinerary } = JSON.parse(sessionStorage.getItem("generalInformation")) || {};

    //handle opening the flight deatails modal
    const [openIntFlightDetails, setOpenIntFlightDetails] = useState(false);
    const [typeDetails, setTypeDetails] = useState("");
    const [selectedFlightItem, setSelectedFlightItem] = useState("");
    const handleSelectedTicket = (type, flight) => {
        setOpenIntFlightDetails(true);
        setTypeDetails(type);
        setSelectedFlightItem(flight);
    };

    //hanlde closeing the modal
    useEffect(() => {
        if (!searchParams.get("action")) {
            setOpenIntFlightDetails(false);
        }
    }, [searchParams]);

    return (
        <Grid container item xs={12} rowGap={2} justifyContent="center" alignItems="flex-start">
            <Grid container item xs={12} justifyContent="space-between" alignItems="center">
                <BaseTitle
                    title={`${t("flightList")}:`}
                    dividerColor="1px solid var(--medium-gray-color)"
                    button={
                        !intFlightInformation.returnDate && (
                            <DayChange
                                label="intFlightInformation"
                                information={intFlightInformation}
                                date={flightList?.segments?.[0]?.departure_date}
                                isDeparture={true}
                                setRequestFlag={setRequestFlag}
                                setUid={setUid}
                            />
                        )
                    }
                />
            </Grid>

            <Grid className="flight-list" container item xs={12} rowGap={2} mb={5}>
                {flightList?.map(flightItem => {
                    return <IntFlightItem key={Math.random()} flightItem={flightItem} handleSelectedTicket={handleSelectedTicket} isFull={false} />;
                })}
            </Grid>

            <IntFlightDetailsModal
                open={openIntFlightDetails}
                setOpen={setOpenIntFlightDetails}
                flightItem={selectedFlightItem}
                typeDetails={typeDetails}
            />
        </Grid>
    );
}

function mapStateToProps(state) {
    return {
        departureFullFlightList: state.departureFullFlightList,
        returnFullFlightList: state.returnFullFlightList,
    };
}

export default connect(mapStateToProps)(IntFlightList);
